import * as moment from 'moment';
import { Injectable } from "@angular/core";

import { Updates, Projects, Users } from 'api/collections';
import { Activity } from 'api/models';
import * as permissions from '../services/permissions';
import { ISDEV } from "./config";
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { MeteorUser, AuthenticationService } from './congito';

export type AugmentedActivity = Activity & {
  isDueToday: boolean,
  daysLate: number,
  percentComplete?:number,
  taskType: string,
  targetStart: Date,
  targetFinish: Date,
  blFinishDelta: number,
  blStartDelta: number,
  viewerHasTotalFloatPermission: boolean,
  todayVsScheduledStart: number
  todayVsScheduledEarlyStartTask: number,
  initialActualStart: any,


};



@Injectable()
export class ActivityService {
  public isDev = ISDEV;

  constructor(
    private authService: AuthenticationService,
  ) {}

  getAugmentedActivity(activity: Activity): AugmentedActivity {
    if(activity.actualStart) {console.log("activity.actualStartactivity.actualStartactivity.actualStartactivity.actualStart", activity.actualStart)}
  
  
  
   if(this.isDev == true) { console.log('activity data cp1'); }
    const viewer = MeteorUser();
    const isDev = ISDEV;
    const momentFormat = 'YYYY-MM-DD HH:mm';
    const momentInitialActualStart = moment(activity.taskRow.act_start_date, momentFormat);
  
    const initialActualStart = momentInitialActualStart.isValid() ? momentInitialActualStart.toDate() : undefined;
    const targetStart = activity.earlyStart ? moment(activity.earlyStart) : undefined;
    const targetFinish = activity.earlyFinish ? moment(activity.earlyFinish) : undefined;
    const actualFinish = moment(activity.actualFinish || Date.now());
    const targetStartDate = targetStart.toDate();
    const targetFinishDate = targetFinish.toDate();
    const daysLate = (actualFinish ? actualFinish.startOf('day') : moment().startOf('day')).diff(targetFinish.startOf('day'), 'days');
    const todayVsScheduledStart = moment(activity.earlyStart).diff(Date.now(), 'days');
    const todayVsScheduledEarlyStartTask = moment(Date.now(), 'days').diff(targetStart);
    let viewerHasTotalFloatPermission = false;
    const update = Updates.findOne(activity.updateId);
    const project = Projects.findOne(activity.projectId);
    let calculatedOriginalDuration = 0;
  
    if(this.isDev == true) { console.log('activity data cp2'); }
  
    if (update && project && viewer) {
      viewerHasTotalFloatPermission = permissions.userCanViewTotalFloat(viewer._id, project, update);
    }
    //calculate the original duration
    // console.log('initial Actual Start: '+initialActualStart);
  
  
  
  if(this.isDev == true) { console.log('activity data cp3'); }
  // console.log("moment.utc(activity.actualStart).toDate()", moment(activity.actualStart, momentFormat).toDate())
  // console.log("moment.utc(activity.actualFinish).toDate()", moment(activity.actualFinish, momentFormat).toDate())
  
  let earlyStartMoment = moment(activity.earlyStart, momentFormat);
  // earlyStartMoment = earlyStartMoment.subtract(earlyStartMoment.utcOffset(), 'm');
  const earlyStartDate = earlyStartMoment.isValid() ? earlyStartMoment.toDate() : activity.earlyStart;
  
  let earlyFinishMoment = moment(activity.earlyFinish, momentFormat);
  // earlyFinishMoment = earlyFinishMoment.subtract(earlyFinishMoment.utcOffset(), 'm');
  const earlyFinishDate = earlyFinishMoment.isValid() ? earlyFinishMoment.toDate() : activity.earlyFinish;
  
  
  let actualStartMoment = moment(activity.actualStart, momentFormat);
  if(activity.actualStart) {console.log("actualStartMomentactualStartMomentactualStartMomentactualStartMoment", actualStartMoment)}
  // actualStartMoment = actualStartMoment.subtract(actualStartMoment.utcOffset(), 'm');
  const actualStartDate = actualStartMoment.isValid() ? actualStartMoment.toDate(): activity.actualStart;
  
  if(activity.actualStart) {console.log("actualStartDateactualStartDateactualStartDateactualStartDate", actualStartDate)}
  
  let actualFinishMoment = moment(activity.actualFinish, momentFormat);
  // actualFinishMoment = actualFinishMoment.subtract(actualFinishMoment.utcOffset(), 'm');
  const actualFinishDate = actualFinishMoment.isValid() ? actualFinishMoment.toDate() : activity.actualFinish;
  
    return {
      targetStart: targetStartDate,
      targetFinish: targetFinishDate,
      initialActualStart,
      isDueToday: daysLate === 0 && moment().isSame(targetFinish, 'day'),
      daysLate,
      todayVsScheduledStart,
      todayVsScheduledEarlyStartTask,
      viewerHasTotalFloatPermission,
      blFinishDelta: moment(targetFinishDate).diff(activity.actualFinish || new Date(), 'days'),
      blStartDelta: moment(targetStartDate).diff(activity.actualStart || new Date(), 'days'),
      ...activity,
      actualStart: actualStartDate,
      actualFinish: actualFinishDate,
      earlyStart: earlyStartDate,
      earlyFinish: earlyFinishDate,
  
    };
  }
  
}



// WEBPACK FOOTER //
// ./src/services/activityData.ts